import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FORGOT_PASSWORD_SCHEMA } from '../../utils/forgotPassword.js';
import { useForgotPasswordMutation } from '../../api/auth.js';
import { useErrors } from '../../hooks/useErrors.js';
import GuestLayout from '../../components/layout/GuestLayout.jsx';
import BaseInput from '../../components/form/BaseInput.jsx';
import BaseButton from '../../components/form/BaseButton.jsx';
import BaseLink from '../../components/misc/BaseLink.jsx';

const ForgotPassword = () => {
    const [forgotPassword, { isLoading, error }] = useForgotPasswordMutation();

    const { handleSubmit, getValues, formState, control, clearErrors } = useForm({
        resolver: yupResolver(FORGOT_PASSWORD_SCHEMA),
        defaultValues: {
            email: ''
        },
        reValidateMode: 'onSubmit'
    });

    const { errors } = useErrors(error?.message, formState);

    const sendForgotPassword = async (requestData) => {
        await forgotPassword({
            email: requestData.email
        });
    };

    const formValues = getValues();

    return (
        <GuestLayout title='Forgot Password'>
            <div className='mb-10'>
                <BaseInput
                    type='text'
                    control={control}
                    placeholder='Email'
                    name='email'
                    clearErrors={clearErrors}
                    errors={[...(errors?.email ? errors.email : [])]}
                />

                <BaseButton
                    id='btn-submit'
                    className='mt-10 btn-primary-white'
                    onClick={handleSubmit(sendForgotPassword)}
                    isLoading={isLoading}
                    textValue='Send reset password email'
                    disabled={!formValues.email}
                />
            </div>
            <div className='flex justify-center'>
                <BaseLink className='btn-link-guest-white' to='/login'>
                    Sign In
                </BaseLink>
            </div>
        </GuestLayout>
    );
};
export default ForgotPassword;
